const isMobileDevice = () => {
    // Use Tailwind's sm breakpoint (640px)
    return window.innerWidth < 640;
  };
  
  export const toggleScrollLock = (lock) => {
    // Only apply scroll lock on mobile devices
    if (!isMobileDevice()) return;
  
    if (lock) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      document.body.style.overscrollBehavior = 'none';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.body.style.overscrollBehavior = '';
    }
  };
  
  // Add resize listener to handle orientation changes
  window.addEventListener('resize', () => {
    if (!isMobileDevice()) {
      // Reset any scroll lock styles when viewport becomes larger than mobile
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.body.style.overscrollBehavior = '';
    }
  });